module.exports = __webpack_public_path__ + "assets/docker.69eae24c.svg";